module.exports = __webpack_public_path__ + "img/Susan_Parker.09be0c59.png";